<template lang="pug">
  b-form-select(
    :value="value"
    :size="size"
    @input="handleInput"
    )
    template(v-if="isAll")
      option(value="") {{ $t("ui.all") }}
    template(v-else)
      option(value="" :disabled="isDisabled") {{ $t("message.select_option") }}
    option(v-for="option in options" :value="option.provider_code") {{ option.provider_name }}
</template>

<script>
import config from "@/config";

export default {
  props: {
    value: {
      type: String,
      default: ""
    },
    size: {
      type: String,
      default: "md"
    },
    dirty: {
      type: Boolean,
      default: false
    },
    error: {
      type: Boolean,
      default: false
    },
    isDisabled: {
      type: Boolean,
      default: false
    },
    operatorID: {
      type: String,
      default: null
    },
    isAll: {
      type: Boolean,
      default: false
    },
    category: {
      type: String,
      default: null
    },
    isFree: {
      type: Boolean,
      default: false
    },
    creditType: {
      type: String,
      default: null
    },
    isReport: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    options: [],
    feedback: {
      success: true,
      status: ""
    }
  }),
  mounted: function() {
    if(this.$store.getters.sessionToken) {
      this.getProviderList();
    }
  },
  methods: {
    getProviderList: function() {
      let url = config.providerMaintenanceOperatorListUrl();

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        category: this.category,
        operator_id: this.operatorID,
        is_free: this.isFree,
        credit_type: this.creditType
      };

      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                if(!this.isReport)
                  this.options = (response.data.dt || []).filter(item => item.aggregator !== "GTA");
                else
                  this.options = response.data.dt;
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    handleInput(e) {
      this.$emit("input", e);
    }
  }
};
</script>
